// Utils
import hasRole from './hasRole'

// Constants
import {
  ROLE_SUPERUSER,
} from '../constants'

// Exports
export default hasRole(ROLE_SUPERUSER)
